<template>
  <div class="headerbar">
        <div class="headertext clear">
          <a href="#" class="logo"><img src="../../assets/image/top_logo.jpg"/></a>
          <div class="Tips" @click="navbar">
              <i>  <img src="../../assets/image/icon_menu.png"/></i>
          </div>
        </div>
       <transition name="fade" >
       <div class="nav" v-show="isshow">
           <ul @click='tab'>
              <router-link to="/index" tag="li" activeClass="active" exact><span>首页</span></router-link>
              <li @click="openPru">
                <span class="produce">产品 
                   <i v-show="isOpenProduce"><img src="../../assets/image/icon_shouqi.png"/></i>
                   <i v-show="!isOpenProduce"><img src="../../assets/image/icon_zhankai.png"/></i>
                </span>
                <div class="produceNav" v-show="isOpenProduce">

                  <router-link to="/product/marketing" tag="p" activeClass="active" exact><span>智能电话机器人</span></router-link>
                  <router-link to="/product/IVR" tag="p" activeClass="active" exact><span>电话外呼系统</span></router-link>
                  <router-link to="/product/enterPrise" tag="p" activeClass="active" exact><span>企业客服系统</span></router-link>
                  <router-link to="/product/bigData" tag="p" activeClass="active" exact><span>大数据中台</span></router-link>
                  <router-link to="/product/customerService" tag="p" activeClass="active" exact><span>语音中间件平台</span></router-link>
                  <router-link to="/product/proHotline" tag="p" activeClass="active" exact><span>心理援助热线系统</span></router-link>
                 <!-- <router-link to="/product/speechAnalysis" tag="p" activeClass="active" exact><span>智能质检iCheck</span></router-link>
                  <router-link to="/product/seatAssistant" tag="p" activeClass="active" exact><span>智能AI助手iAssist</span></router-link>-->

                </div>
              </li> 
              <router-link to="/product" tag="li" activeClass="active" exact><span>服务</span></router-link>
              <router-link to="/teamwork" tag="li" activeClass="active" exact><span>合作加盟</span></router-link> 
              
              <li @click="openAb">
                 <span class="produce">关于我们
                   <i v-show="isOpenAbout"><img src="../../assets/image/icon_shouqi.png"/></i>
                   <i v-show="!isOpenAbout"><img src="../../assets/image/icon_zhankai.png"/></i>
                </span>
                <div class="produceNav" v-show="isOpenAbout">
                    <router-link to="/about" tag="p" activeClass="active" exact><span>公司介绍</span></router-link>
                    <router-link to="/news" tag="p" activeClass="active" exact><span>新闻资讯</span></router-link>
                    

                </div>
              </li>
              <!--<router-link to="/service" tag="li" activeClass="active" exact><span>案例</span></router-link>   
              <router-link to="/information" tag="li" activeClass="active" exact><span>资讯</span></router-link>
               -->
           </ul>
       </div>
      </transition>
      
  </div>
</template>

<script>
import router from "@/router"
export default {
  name: 'headerbar',
  data () {
    return {
       isshow:false,
       isactive:true,
       isOpenProduce:false,
       isOpenAbout:false,
    }
  },
  watch: {
    '$route'(to, from) {
      //console.log(to,from)
      this.isshow=false;
      // 对路由变化作出响应...
      this.isOpenProduce=false;
      this.isOpenAbout=false;
    }
  },
  methods:{
    navbar(){
      this.isshow=!this.isshow;
    },
    tab(){
      // router.afterEach((to,from,next) => {
      //   this.isshow=false;
      // });
    },
    popup(){
       this.$store.commit("openPop",{isopen:true,type:1})
    },
    onpop(){
       this.$store.commit("openPop",{isopen:true,type:2})
    },
    openPru(){
       this.isOpenProduce=!this.isOpenProduce;
    },
    openAb(){
       this.isOpenAbout=!this.isOpenAbout;
    }
  },
   mounted() { 
      //  var path=this.$route.fullPath
      // if(path=='/product/customerService'||path=='/product/marketing'||path=='/product/IVR'||path=='/product/speechAnalysis'||path=='/product/seatAssistant'){
      //       this.isOpenProduce=true;
      // }else{
      //      this.isOpenProduce=false;
      // }

   }
}
</script>


<style scoped>
.headerbar{
  background:#fff;
  position:fixed;
  top:0;
  width:100%;
  z-index:1111;
  box-shadow: 0 1px 4px 0 rgba(0,0,0,0.10);
}

.headerbar .headertext a.logo{
   float:left;
   width:2rem;
   height:0.7rem;
   margin:0.15rem 0rem 0.15rem 0.1rem;
}
.headerbar .headertext a.logo img{
  display:block;
  width:2rem;
  height:0.7rem;
}

.headerbar .Tips{
  float:right;
  width:0.40rem;
  height:0.32rem;
  margin:0.3rem 0.3rem 0 0;
}
.headerbar .Tips i{
  display:block;
   width:0.5rem;
  height:0.46rem;
}
.headerbar .Tips img{
  display:block;
  width:0.5rem;
  height:0.46rem;
}
.headerbar .nav{
   width:5.6rem;
   background:#fff;
   position:absolute;
   top:1rem;
   right:0;
   border-bottom-right-radius:0.1rem;
   border-bottom-left-radius:0.1rem;
   -moz-border-bottom-right-radius:0.1rem;
   -moz-border-bottom-left-radius:0.1rem;
   -webkit-border-bottom-right-radius:0.1rem;
   -webkit-border-bottom-left-radius:0.1rem;
   box-shadow:0  0.06rem 0.06rem rgba(0,0,0,0.1);
   
}

.headerbar .nav ul li{
   width:100%;
   border-bottom:0.02rem solid #ccc;
   font-size:0.3rem;
   line-height:0.9rem;
   color:#333;
}
.headerbar .nav ul li span{
  display:block;
  margin-left:0.55rem;
}
.headerbar .nav ul li span.produce i{
   float:right;
   width:0.35rem;
   height:0.15rem;
   margin-right:0.75rem;
}
.headerbar .nav ul li span.produce i img{
   width:0.35rem;
   height:0.15rem;
}
.headerbar .nav ul li .produceNav span{
 
 margin-left:0.99rem;
}
.headerbar .nav ul li .produceNav{
   border-top:0.02rem solid rgba(255,255,255,0.2);
}
.headerbar .nav ul li .produceNav p{
 border-bottom:0.02rem solid rgba(255,255,255,0.2);
}
.headerbar .nav ul li .produceNav p:last-child{
  border-bottom:none;
}
.headerbar .nav ul li:last-child{
  border-bottom:none;
}
.headerbar .nav ul li.active{
  background:#307EFF;
}
.headerbar .nav ul li.active span{
  color:#fff;
}
.headerbar .nav ul li .active{
  background:#307EFF;
}
.headerbar .nav ul li .active span{
  color:#fff;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/public/headerbar.vue